import { classes } from '../../../../lib/utils/cssUtils';
import styles from './Separator.module.scss';
import { MappedAEMProperties } from '../../../../types';

export const PureSeparator = ({
  className,
  asDiv,
  isInEditor,
}: { className?: string; asDiv?: true } & Partial<MappedAEMProperties>) => {
  const clazz = classes({ [styles.asDiv]: asDiv, [styles.authoring]: isInEditor }, styles.separator, className);

  return asDiv ? <div className={clazz} /> : <hr className={clazz} />;
};

const Separator = (props: MappedAEMProperties) => <PureSeparator {...props} />;

export default Separator;
